interface IconZaloProps {
  className?: string
}
export const IconZalo = ({ className }: IconZaloProps) => {
  return (
    <img
      src='/assets/icons/sidebar/zalo.svg'
      alt='zalo'
      className={className}
    />
  )
}
